import * as classnames from 'classnames'
import * as React from 'react'

import TrendingSash from '../../../components/trendingSash'
import SaleSash from '../../../components/saleSash'
import { IItemCard } from '../interface'
import Preview from '../lockupPreview'
import LockupPreviewActionPanel from '../lockupPreviewActionPanel'

import * as styles from './itemCardLandscapePreview.module.css'

interface IProps extends IItemCard {
  carousel?: boolean
}

const ItemCardLandscapePreview = (props: IProps) => {
  const {
    item,
    onItemLinkClick,
    isCardHovered,
    viewType,
    carousel = false
  } = props

  const rootClass = classnames({
    [styles.listView]: viewType === 'list',
    [styles.isCardHovered]: isCardHovered
  })

  // sale sash overrides trending sash
  let sash = null
  if (item.trending) sash = <TrendingSash lazy large />

  // For author driven price experiment
  if (item.original_price_cents) sash = <SaleSash large />

  return (
    <section className={rootClass}>
      {sash}
      <Preview
        item={item}
        onItemLinkClick={onItemLinkClick}
        carousel={carousel}
      />
      <section className={styles.hoverOverlay}>
        <a
          href={`${item.url}`}
          onClick={onItemLinkClick}
          className={styles.hoverOverlayClickHandler}
          role="toolbar"
          title={item.name}
        />
        <section className={styles.hoverOverlayActions}>
          <LockupPreviewActionPanel {...props} />
        </section>
      </section>
    </section>
  )
}

export default ItemCardLandscapePreview
